var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archive-root-container"},[_c('div',{staticClass:"archive-main-container"},_vm._l((_vm.taskList),function(item){return _c('task-set-item',{key:item.task_id,attrs:{"dataSource":item},nativeOn:{"click":function($event){return _vm.goDetail(item)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }